// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"45da2fef","243":"238edc3b","261":"b42fac69","338":"5fd86b7b","456":"ea01c0ff","541":"197cc90c","544":"93ef9b61","576":"ceae9f4a","753":"e1719047","775":"d8141f0a","823":"a37fdb3a","980":"d06b995f"}[chunkId] + ".js";
};